
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class BoxConfirmation extends Vue {
    private loading: boolean = true;
    private status: "loading" | "success" | "error" | "notFound" = "loading";
    private box: any | null = null;

    public async mounted() {
        this.updateBatteryDate();
    }

    private async updateBatteryDate() {
        this.loading = true;
        this.status = "loading";

        try {
            const id = this.$route.params.id;
            const box = await this.$store.dispatch("public/connectedBoxes/updateBatteryDate", id);

            if (box && box.id) {
                this.box = box;
                this.status = "success";
            } else {
                this.status = "error";
            }

        } catch (err: any) {
            if (err?.response?.status === 404) {
                this.status = "notFound";
            } else {
                this.status = "error";
            }
        } finally {
            this.loading = false;
        }
    }

    private goBackOrHome() {
        const from = this.$route.query.from as string | undefined;

        if (from) {
            this.$router.push(from);
        } else {
            this.$router.push({ name: "home" });
        }
    }
}
